var _path, _rect, _ellipse, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPadlock = function SvgPadlock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9324 26.0392V13.0743C29.9324 9.4942 27.0302 6.59191 23.45 6.59191C19.8699 6.59191 16.9676 9.4942 16.9676 13.0743V26.0392C16.9676 29.6194 19.8699 32.5216 23.45 32.5216C27.0302 32.5216 29.9324 29.6194 29.9324 26.0392ZM23.45 2.60272C17.6667 2.60272 12.9784 7.29103 12.9784 13.0743V26.0392C12.9784 31.8225 17.6667 36.5108 23.45 36.5108C29.2333 36.5108 33.9216 31.8225 33.9216 26.0392V13.0743C33.9216 7.29103 29.2333 2.60272 23.45 2.60272Z",
    fill: "#C4C4C4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16.5649,
    width: 36.9,
    height: 24.9324,
    rx: 3.67567,
    fill: "#DFDFDF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.4501,
    cy: 27.4408,
    rx: 3.48143,
    ry: 3.48143,
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0576 26.7446L24.8428 26.7446L25.539 35.1001L21.3613 35.1001L22.0576 26.7446Z",
    fill: "#626262"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPadlock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/padlock.9dc10b2c4b8695bef14e79d4ea1914a8.blank.svg";